import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { SignInController } from '@/views/portal/sign_in/SignInController';
import { TTAPI } from '@/services/TimeTrexClientAPI';

export class PortalJobVacancyViewController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			el: '#job_vacancy_view_container',

		} );

		super( options );
	}

	init( options ) {
		this.api = TTAPI.APIJobVacancyPortal;
		this.script_name = 'JobVacancyView';
		this.render();
		TTPromise.resolve( 'IndexController', 'onViewChange' );
	}

	search() {
		var $this = this;
		this.onSearchClick( {
			callback: function() {
				if ( LocalCacheData.getAllURLArgs().sm === 'ResetPassword' && LocalCacheData.getAllURLArgs().key && LocalCacheData.getAllURLArgs().company_id ) {
					var signInController = new SignInController();
				}
			}
		} );
	}

}

PortalJobVacancyViewController.html_template = `
<div id="job_vacancy_view_container">
	<div class="search-bar">
		<div class="container">
			<form>
				<div class="row">
					<div class="col-md-3">
						<div class="form-group">
							<label class="sr-only" for="name">title</label>
							<input class="form-control" id="name" placeholder="<%= $.i18n._('Search Title') %>">
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label for="country" class="sr-only">country</label>
							<div class="styled-select">
								<select class="form-control" id="country"></select>
							</div>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label for="province" class="sr-only">province</label>
							<div class="styled-select">
								<select class="form-control" id="province">
									<option value=""><%= $.i18n._('All Province/States') %></option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label for="city" class="sr-only">city</label>
							<input class="form-control" id="city" placeholder="<%= $.i18n._('Search City') %>">
						</div>
					</div>
					<div class="col-md-3">
						<button type="button" class="btn btn-block btn-default search-btn w-100"><%= $.i18n._('Search') %> <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></button>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="search-result">
		<div class="content container"></div>
		<div class="more container">
			<div class="row">
				<button type="button" class="btn btn-primary btn-lg btn-block"><%= $.i18n._('Loading') %>...</button>
			</div>
		</div>
	</div>
</div>

`;
